import React from "react";

const OTCReferNote = () => {
  return (
    <div className="bg-white p-2  flex flex-col max-w-[355px] ">
      <p className="text-gray-800 text-sm  font-normal">
        Module Coming Soon
      </p>
    </div>
  );
};

export default OTCReferNote;
